(function () {
  'use strict';

  /* @ngdoc object
   * @name postponedMatches
   * @description
   *
   */
  angular
    .module('neo.home.postponements.postponedMatches', [
      'ui.router'
    ]);
}());
